import '../sass/horse-profile.scss';

import { openModal } from '../../../../assets/src/js/common/modals';

(() => {
    const $templateParts = document.querySelectorAll('.horse-profile');

    if (!$templateParts) return;

    $templateParts.forEach($templatePart => {
        const $searchDropdown = $templatePart.querySelector('.horse-profile-search-dropdown__dropdown');
        const $links = $templatePart.querySelectorAll('.horse-profile-nav__link');
        const $panels = $templatePart.querySelectorAll('.horse-profile-panel');
        const $select = $templatePart.querySelector('.horse-profile-statistics__select');
        const $statisticsTables = $templatePart.querySelectorAll('.horse-profile-statistics__table');
        const $statisticsListItems = $templatePart.querySelectorAll('.horse-profile-statistics__list-item');
        const $videoModal = $templatePart.querySelector('.horse-profile-video-modal');
        const $videoPlayer = $templatePart.querySelector('.horse-profile-video-modal__video-player');
        const $formTableBody = $templatePart.querySelector('.horse-profile-form__table-body');
        const $formList = $templatePart.querySelector('.horse-profile-form__list');
        const $winsTableBody = $templatePart.querySelector('.horse-profile-wins__table-body');
        const $winsList = $templatePart.querySelector('.horse-profile-wins__list');
        const $formLoadMore = $templatePart.querySelector('.horse-profile-form__load-more');
        const $winsLoadMore = $templatePart.querySelector('.horse-profile-wins__load-more');

        let fetchHorseResultsController;

        const initSearchDropdown = () => {
            if (!$searchDropdown) return;

            new Details($searchDropdown);
        };

        const initLinks = () => {
            if (!$links || !$panels) return;

            $links.forEach($link => {
                $link.addEventListener('click', e => {
                    e.preventDefault();
                    
                    const { panel } = $link.dataset;

                    const $panels = document.querySelectorAll(`.horse-profile-panel`);

                    $links.forEach($link => {
                        if ($link.dataset.panel === panel) {
                            $link.classList.add('btn--solid', 'btn--disabled');
                            $link.classList.remove('btn--outline');
                        } else {
                            $link.classList.remove('btn--solid', 'btn--disabled');
                            $link.classList.add('btn--outline');
                        }
                    });

                    $panels.forEach($panel => {
                        if ($panel.classList.contains(`horse-profile-panel--${panel}`)) {
                            $panel.classList.add('horse-profile-panel--show');
                        } else {
                            $panel.classList.remove('horse-profile-panel--show');
                        }
                    });

                    history.replaceState(null, null, $link.href);
                });
            });
        };

        const initStatisticsSelect = () => {
            if (!$select) return;

            $select.addEventListener('change', e => {
                e.preventDefault();

                const { value } = e.target;

                $statisticsTables.forEach($table => {
                    if ($table.classList.contains(`horse-profile-statistics__table--${value}`)) {
                        $table.classList.remove('horse-profile-statistics__table--hide');
                    } else {
                        $table.classList.add('horse-profile-statistics__table--hide');
                    }
                });

                $statisticsListItems.forEach($item => {
                    if ($item.classList.contains(`horse-profile-statistics__list-item--${value}`)) {
                        $item.classList.remove('horse-profile-statistics__list-item--hide');
                    } else {
                        $item.classList.add('horse-profile-statistics__list-item--hide');
                    }
                })
            });
        };

        const initModals = () => {
            if (!$videoModal) return;

            const $videoModalBtns = $templatePart.querySelectorAll('.horse-profile-video-modal-btn');

            if ($videoModalBtns) {
                $videoModalBtns.forEach($btn => {
                    if ($btn.classList.contains('horse-profile-video-modal-btn--init')) return;

                    $btn.classList.add('horse-profile-video-modal-btn--init');

                    const { vimeoVideoId } = $btn.dataset;

                    $btn.addEventListener('click', () => {
                        let videoPlayer;

                        if ($videoPlayer) {
                            $videoPlayer.innerHTML = `<iframe src="https://player.vimeo.com/video/${vimeoVideoId}?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media&controls=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`
                            videoPlayer = new Plyr($videoPlayer);
                            videoPlayer.play();
                        }

                        $videoModal.addEventListener('modalafterclose', () => {
                            videoPlayer?.stop();
                        });

                        openModal($videoModal);
                    });
                });
            }
        };

        const initLoadMore = () => {
            if ($formLoadMore) {
                $formLoadMore.addEventListener('submit', e => {
                    e.preventDefault();

                    fetchHorseResults({
                        $loadMoreEl: $formLoadMore,
                        $tableResultsEl: $formTableBody,
                        $listResultsEl: $formList,
                        wins: false,
                    });
                });
            }

            if ($winsLoadMore) {
                $winsLoadMore.addEventListener('submit', e => {
                    e.preventDefault();

                    fetchHorseResults({
                        $loadMoreEl: $winsLoadMore,
                        $tableResultsEl: $winsTableBody,
                        $listResultsEl: $winsList,
                        wins: true,
                    });
                });
            }
        };

        const fetchHorseResults = async ({
            $loadMoreEl,
            $tableResultsEl,
            $listResultsEl,
            wins = false,
        }) => {
            if (fetchHorseResultsController) {
                fetchHorseResultsController.abort();
            }

            fetchHorseResultsController = new AbortController();

            const $horseId = $loadMoreEl?.querySelector('[name="horse_id"]');
            const $nonce = $loadMoreEl?.querySelector('[name="_wpnonce"]');
            const $formsPage = $loadMoreEl?.querySelector('[name="forms_page"]');
            const $winsPage = $loadMoreEl?.querySelector('[name="wins_page"]');

            const fetchParams = new URLSearchParams();

            fetchParams.set('id', $horseId?.value);

            if ($formsPage) {
                fetchParams.set('page', $formsPage?.value);
            }

            if ($winsPage) {
                fetchParams.set('page', $winsPage?.value);
            }

            fetchParams.set('wins', wins ? 1 : 0);

            $loadMoreEl.classList.add('horse-profile-load-more--loading');

            try {
                fetch('/wp-json/point-to-point/horse-form-results?' + fetchParams.toString(), {
                    method: 'GET',
                    signal: fetchHorseResultsController.signal,
                    headers: {
                        'X-WP-Nonce' : $nonce?.value,
                    },
                }).then(async response => {
                    if (!response.ok) {
                        throw new Error(`Response status: ${response.status}`);
                    }

                    const json = await response.json();
                
                    return json;
                }).then(json => {
                    if ($listResultsEl) {
                        $listResultsEl.insertAdjacentHTML('beforeend', json?.list_html ?? '');
                    }
                    
                    if ($tableResultsEl) {
                        $tableResultsEl.insertAdjacentHTML('beforeend', json?.table_html ?? '');
                    }

                    if (!json?.load_more) {
                        $loadMoreEl.classList.add('horse-profile-load-more--hide');
                    }

                    const params = new URLSearchParams(document.location.search);

                    if ($formsPage) {
                        params.set('forms_page', parseInt($formsPage.value));

                        $formsPage.value = parseInt($formsPage.value) + 1;
                    }

                    if ($winsPage) {
                        params.set('wins_page', parseInt($winsPage.value));

                        $winsPage.value = parseInt($winsPage.value) + 1;
                    }

                    history.replaceState(null, null, '?' + params.toString());

                    initModals();

                    $loadMoreEl.classList.remove('horse-profile-load-more--loading');
                });
            } catch (error) {
                $loadMoreEl.classList.remove('horse-profile-load-more--loading');
            }
        }

        initSearchDropdown();
        initLinks();
        initStatisticsSelect();
        initModals();
        initLoadMore();
    });
})();
